function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import "regenerator-runtime/runtime.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.assign.js";
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Tabs, Tab, Row, Col, Button, BackButton, BorrowerDetailsTab, BorrowerDocumentsTab, BorrowerContractsTab, BorrowerCreditsTab, BorrowerContactsTab, BorrowerHistoryTab, BorrowerActionsTab, BorrowerWorkPlaceTab, BorrowerIncomeTab, BorrowerExpenseTab, BorrowerExternalCreditTab, useUser } from 'components';
import { showApiError } from 'utils';
import { getBorrower } from 'services';
import { headerLeftTitle, headerLeftId } from 'styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var BorrowerDetails = function BorrowerDetails(_ref) {
  var _location$state, _match$params;

  var location = _ref.location,
      match = _ref.match,
      history = _ref.history;

  var _ref2 = (_location$state = location.state) !== null && _location$state !== void 0 ? _location$state : {},
      borrower = _ref2.borrower;

  var _ref3 = (_match$params = match.params) !== null && _match$params !== void 0 ? _match$params : {},
      borrowerIdNumber = _ref3.borrowerIdNumber;

  var _useState = useState(borrower),
      _useState2 = _slicedToArray(_useState, 2),
      borrowerData = _useState2[0],
      setBorrowerData = _useState2[1];

  var _useUser = useUser(),
      roleAdditionalData = _useUser.roleAdditionalData;

  useEffect(function () {
    fetchBorrowerData();
  }, []);

  var fetchBorrowerData = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _yield$getBorrower, _yield$getBorrower2, res, err;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getBorrower(borrowerIdNumber);

            case 2:
              _yield$getBorrower = _context.sent;
              _yield$getBorrower2 = _slicedToArray(_yield$getBorrower, 2);
              res = _yield$getBorrower2[0];
              err = _yield$getBorrower2[1];

              if (!err) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return", showApiError(err));

            case 8:
              setBorrowerData(function (prev) {
                return _objectSpread(_objectSpread({}, prev), res);
              });

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchBorrowerData() {
      return _ref4.apply(this, arguments);
    };
  }();

  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Row, {
    justify: "space-between",
    align: "center",
    backgroundColor: "white",
    padding: "2em",
    className: "container-xxl"
  }, ___EmotionJSX(Col, {
    sm: "auto",
    position: "relative",
    margin: "0 0 1.4em"
  }, ___EmotionJSX(BackButton, {
    onBack: function onBack() {
      return history.push('/borrowers');
    }
  }), ___EmotionJSX("h6", {
    css: headerLeftTitle
  }, "\u0415\u0413\u041D: ", borrowerData === null || borrowerData === void 0 ? void 0 : borrowerData.id_number), ___EmotionJSX("div", {
    css: headerLeftId
  }, ___EmotionJSX("span", null, borrowerData === null || borrowerData === void 0 ? void 0 : borrowerData.first_name, " ", borrowerData === null || borrowerData === void 0 ? void 0 : borrowerData.middle_name, " ", borrowerData === null || borrowerData === void 0 ? void 0 : borrowerData.last_name))), ___EmotionJSX(Col, {
    sm: "auto",
    displayFlex: true,
    margin: "0 0 1.4em"
  }, ___EmotionJSX(Row, {
    horizontalGap: 8
  }, ___EmotionJSX(Col, {
    sm: "auto"
  }, ___EmotionJSX(Button, {
    small: true,
    type: "primary",
    linkTo: "/borrowers/details/".concat(borrowerData === null || borrowerData === void 0 ? void 0 : borrowerData.id_number, "/credits"),
    leftIcon: {
      iconName: 'la la-coins',
      size: 18
    }
  }, "\u0412\u044A\u0432\u0435\u0434\u0438 \u0432\u043D\u043E\u0441\u043A\u0430")), (roleAdditionalData === null || roleAdditionalData === void 0 ? void 0 : roleAdditionalData.canIssueCredits) && ___EmotionJSX(Col, {
    sm: "auto"
  }, ___EmotionJSX(Button, {
    small: true,
    type: "success",
    linkTo: {
      pathname: '/credits/new',
      state: {
        borrowerIdNumber: borrowerIdNumber
      }
    },
    leftIcon: {
      iconName: 'la la-plus',
      size: 18
    }
  }, "\u0421\u044A\u0437\u0434\u0430\u0439 \u043A\u0440\u0435\u0434\u0438\u0442"))))), ___EmotionJSX(Tabs, {
    startingRoute: match.url,
    noAnimation: true,
    contentClass: "container-xxl",
    listClass: "container-xxl",
    padding: "0 2em"
  }, ___EmotionJSX(Tab, {
    url: "/info",
    component: function component(data) {
      return ___EmotionJSX(BorrowerDetailsTab, _extends({}, data, {
        borrower: borrowerData,
        onBorrowerChange: function onBorrowerChange(data) {
          return setBorrowerData(function (prev) {
            return _objectSpread(_objectSpread({}, prev), data);
          });
        }
      }));
    },
    label: "\u0414\u0435\u0442\u0430\u0439\u043B\u0438"
  }), ___EmotionJSX(Tab, {
    url: "/documents",
    component: function component(data) {
      return ___EmotionJSX(BorrowerDocumentsTab, _extends({}, data, {
        idNumber: borrowerIdNumber,
        borrower: borrowerData
      }));
    },
    label: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438"
  }), ___EmotionJSX(Tab, {
    url: "/work-place",
    component: function component(data) {
      return borrowerData && ___EmotionJSX(BorrowerWorkPlaceTab, _extends({}, data, {
        idNumber: borrowerIdNumber,
        borrower: borrowerData,
        onBorrowerChange: function onBorrowerChange(data) {
          return setBorrowerData(function (prev) {
            return _objectSpread(_objectSpread({}, prev), {}, {
              work_place: data
            });
          });
        }
      }));
    },
    label: "\u041C\u0435\u0441\u0442\u043E\u0440\u0430\u0431\u043E\u0442\u0430"
  }), ___EmotionJSX(Tab, {
    url: "/income",
    component: function component(data) {
      return ___EmotionJSX(BorrowerIncomeTab, _extends({}, data, {
        idNumber: borrowerIdNumber,
        borrower: borrowerData,
        onBorrowerChange: function onBorrowerChange(data) {
          return setBorrowerData(function (prev) {
            return _objectSpread(_objectSpread({}, prev), {}, {
              incomes: data
            });
          });
        }
      }));
    },
    label: "\u041F\u0440\u0438\u0445\u043E\u0434\u0438"
  }), ___EmotionJSX(Tab, {
    url: "/external-credit",
    component: function component(data) {
      return ___EmotionJSX(BorrowerExternalCreditTab, _extends({}, data, {
        idNumber: borrowerIdNumber,
        borrower: borrowerData,
        onBorrowerChange: function onBorrowerChange(data) {
          return setBorrowerData(function (prev) {
            return _objectSpread(_objectSpread({}, prev), {}, {
              external_credits: data
            });
          });
        }
      }));
    },
    label: "\u0412\u044A\u043D\u0448\u043D\u0438 \u043A\u0440\u0435\u0434\u0438\u0442\u0438"
  }), ___EmotionJSX(Tab, {
    url: "/expense",
    component: function component(data) {
      return borrowerData && ___EmotionJSX(BorrowerExpenseTab, _extends({}, data, {
        idNumber: borrowerIdNumber,
        borrower: borrowerData,
        onBorrowerChange: function onBorrowerChange(data) {
          return setBorrowerData(function (prev) {
            return _objectSpread(_objectSpread({}, prev), {}, {
              expenses: data
            });
          });
        }
      }));
    },
    label: "\u0420\u0430\u0437\u0445\u043E\u0434\u0438"
  }), ___EmotionJSX(Tab, {
    url: "/contracts",
    component: function component(data) {
      return ___EmotionJSX(BorrowerContractsTab, _extends({}, data, {
        borrower: borrowerData
      }));
    },
    label: "\u0414\u043E\u0433\u043E\u0432\u043E\u0440\u0438"
  }), ___EmotionJSX(Tab, {
    url: "/credits",
    component: function component(data) {
      return ___EmotionJSX(BorrowerCreditsTab, _extends({}, data, {
        idNumber: borrowerIdNumber
      }));
    },
    label: "\u041A\u0440\u0435\u0434\u0438\u0442\u0438"
  }), ___EmotionJSX(Tab, {
    url: "/contacts",
    component: function component(data) {
      return ___EmotionJSX(BorrowerContactsTab, _extends({}, data, {
        idNumber: borrowerIdNumber
      }));
    },
    label: "\u041A\u043E\u043D\u0442\u0430\u043A\u0442\u0438"
  }), ___EmotionJSX(Tab, {
    url: "/history",
    component: function component(data) {
      return ___EmotionJSX(BorrowerHistoryTab, _extends({}, data, {
        borrower: borrowerData
      }));
    },
    label: "\u0418\u0441\u0442\u043E\u0440\u0438\u044F"
  }), ___EmotionJSX(Tab, {
    url: "/actions",
    component: function component(data) {
      return ___EmotionJSX(BorrowerActionsTab, _extends({}, data, {
        borrower: borrowerData
      }));
    },
    label: "\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u044F"
  })));
};

BorrowerDetails.propTypes = {
  location: PropTypes.object,
  match: PropTypes.object,
  history: PropTypes.object
};
export default BorrowerDetails;